<template>
    <li class="nav-item dropdown">
        <audio id="audio_notification" src="/sounds/notification.mp3"></audio>
        <a class="nav-icon dropdown-toggle" href="#" id="alertsRemindersExpired" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="position-relative">
                <BellIcon />
                <span v-if="reminders.length" class="badge badge-danger counter">{{reminders.length}}</span>
            </div>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right py-0" aria-labelledby="alertsRemindersExpired">
            <form action="">
                <div class="dropdown-menu-header">
                    истекших напоминаний: {{reminders.length}}
                    <div>
                        <Select2 v-model="user" :options="users" :id="'users'" :settings="{width: '100%'}"/>
                    </div>
                </div>
                <div class="list-group">
                    <div class="list-group-item" v-for="remind in reminders_filtered">
                        <div class="row no-gutters align-items-center">
                            <div class="col-6 font-weight-bold">
                                Заявка <router-link :to="{name: 'request', params: {id: remind.request_id}}">№{{remind.request_id}}</router-link>
                                <span class="small text-muted d-block">{{remind.user.name}}</span>
                            </div>
                            <div class="col-6 text-right"><span class="small text-muted">{{remind.expires_at}}</span></div>
                            <div class="col-12 py-1">
                                {{remind.text}}
                            </div>
                            <div class="col-6 text-center"><router-link class="text-muted small" :to="{name: 'request', params: {id: remind.request_id}}">Перейти</router-link></div>
                            <div class="col-6 text-center"><a @click="todoRemind(remind.id)" class="text-muted small">Завершить</a></div>
                        </div>
                    </div>
                </div>
                <div class="dropdown-menu-footer">
                    <a @click="todoAll" class="text-muted">Завершить всё</a>
                </div>
            </form>

        </div>
    </li>
</template>

<script>
    import {BellIcon} from "vue-feather-icons";
    import axios from "axios";

    // TODO не срабатывают события если переходить между страницами
    export default {
        name: "Reminders",
        components: {BellIcon},
        data: () => ({
            reminders: [],
            ids: [],
            user: 'all',
            echo_channels: [],
        }),
        mounted() {
            let self = this;
            this.fetch();
            if (this.$store.getters['auth/user'].call_centers && this.$store.getters['auth/user'].call_centers.length) {
                _.forEach(this.$store.getters['auth/user'].call_centers, (cc) => {
                    this.echo_channels.push(`call_center.${cc.id}`);
                    Echo.private(`call_center.${cc.id}`)
                        .listen('.request_reminder.expired', function (e) {
                          if (!self.ids.includes(e.request_reminder.id)) {
                            self.ids.push(e.request_reminder.id);
                            self.reminders.unshift(e.request_reminder);
                            self.pushAlert(e.request_reminder);
                          }
                        })
                })
            }
            this.$bus.$on(['request_reminder:create', 'request_reminder:done'], function () {
                self.fetch(true);
            });
        },
        beforeDestroy() {
            this.$bus.$off(['request_reminder:create', 'request_reminder:done']);
            _.forEach(this.echo_channels, c => {
              Echo.leave(c);
            })
        },
        computed: {
            users() {
                let u = this.$store.getters['auth/user'];
                let users = [{id: 'all', text: 'Показать все'}, {id: u.id, text: 'Свои'}];
                this.reminders.forEach(function (r) {
                    users.push({id: r.user.id, text: r.user.name});
                });
                users = _.uniqBy(users, 'id');
                return users;
            },
            reminders_filtered() {
                if (this.user && this.user !== 'all'){
                    return _.filter(this.reminders,(r) => {
                        return +r.user.id === +this.user;
                    })
                }
                return this.reminders;
            },
        },
        methods: {
            fetch(alerts = false) {
                let self = this;
                this.$store.dispatch('reminders/fetchExpired').then(function () {
                    let new_ids = [];
                    let reminders = [];
                    self.$store.getters['reminders/expired'].forEach(function (item) {
                        reminders.push(item);
                        new_ids.push(item.id);
                        if (alerts && self.ids.indexOf(item.id) === -1) {
                            self.pushAlert(item);
                        }
                    });
                    self.ids = new_ids;
                    self.reminders = reminders;
                });
            },
            pushAlert(remind) {
                let self = this;
                this.$vs.notification({
                    position: 'bottom-right',
                    duration: 3000,
                    title: 'Напоминание! Заявка №' + remind.request_id,
                    text: remind.text,
                    clickClose: true,
                    onClick: function () {
                        self.toRequest(remind.request_id);
                    }
                });
                try {
                    audio_notification.play();
                } catch (e) {

                }
            },
            toRequest(id) {
                this.$router.push({
                    name: 'request',
                    params: {
                        id: id
                    }
                });
            },
            todoRemind(id) {
                let self = this;
                axios.get('/api/request_reminders/' + id + '/done').then(function () {
                    self.$bus.$emit('request_reminder:done');
                });
            },
            async todoAll() {
                for (const item of this.reminders_filtered) {
                    await axios.get('/api/request_reminders/' + item.id + '/done');
                }
                this.$bus.$emit('request_reminder:done');
            }
        }
    }
</script>

<style scoped>
    #alertsRemindersExpired .counter {
     font-size: 0.8rem;
     position: absolute;
     top: 2px;
     left: 10px;
     padding: 3px;
 }
</style>
